import { render } from "./DesignSizeRow.vue?vue&type=template&id=9accf148&scoped=true"
import script from "./DesignSizeRow.vue?vue&type=script&lang=js"
export * from "./DesignSizeRow.vue?vue&type=script&lang=js"

import "./DesignSizeRow.vue?vue&type=style&index=0&id=9accf148&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9accf148"]])

export default __exports__